module.exports = __webpack_public_path__ + "static/media/site.8570b54b.svg";